import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import Button from '../../components/ui/Button';
import FilterToolbar from './components/FilterToolbar';
import BulkOperations from './components/BulkOperations';
import IncidentsTable from './components/IncidentsTable';
import Pagination from './components/Pagination';
import QuickStats from './components/QuickStats';
import Icon from '../../components/AppIcon';


const IncidentsList = () => {

  const [incidents, setIncidents] = useState([]);


  useEffect(() => {
    const fetchIncidents = async () => {
      try {
          const response = await fetch(`${import.meta.env.VITE_APP_SERVER_URL}/incident`);
          const data = await response.json();
          if (!data.message) {
            setIncidents(data);
          }
      } catch (error) {
        setIncidents([])
      }
    };
    fetchIncidents();
  }, []);

  const navigate = useNavigate();
  
  // Mock user data
  const mockUser = {
    id: 1,
    name: "Sarah Chen",
    email: "sarah.chen@cyberguard.gov",
    role: "Senior Analyst",
    permissions: ["view_dashboard", "view_incidents", "create_incident", "view_reports", "view_settings"]
  };

  // Mock incidents data
  // const incidents = [
  //   {
  //     id: "INC-2024-001",
  //     title: "Suspicious Network Activity Detected",
  //     description: "Multiple failed login attempts from foreign IP addresses targeting administrative accounts",
  //     status: "open",
  //     severity: "critical",
  //     createdAt: "2024-09-19T08:30:00Z",
  //     updatedAt: "2024-09-19T10:15:00Z",
  //     assignee: "John Doe",
  //     impactedSystems: ["Web Server", "Database", "Firewall"],
  //     tags: ["network", "authentication", "brute-force"]
  //   },
  //   {
  //     id: "INC-2024-002",
  //     title: "Malware Detection on Endpoint",
  //     description: "Advanced persistent threat detected on workstation in finance department",
  //     status: "in-progress",
  //     severity: "high",
  //     createdAt: "2024-09-19T07:45:00Z",
  //     updatedAt: "2024-09-19T09:30:00Z",
  //     assignee: "Sarah Chen",
  //     impactedSystems: ["Endpoint Security", "Email System"],
  //     tags: ["malware", "apt", "finance"]
  //   },
  //   {
  //     id: "INC-2024-003",
  //     title: "Phishing Email Campaign",
  //     description: "Large-scale phishing campaign targeting employee credentials with fake login pages",
  //     status: "resolved",
  //     severity: "medium",
  //     createdAt: "2024-09-18T14:20:00Z",
  //     updatedAt: "2024-09-19T11:00:00Z",
  //     assignee: "Mike Johnson",
  //     impactedSystems: ["Email System", "Web Server"],
  //     tags: ["phishing", "social-engineering", "email"]
  //   },
  //   {
  //     id: "INC-2024-004",
  //     title: "DDoS Attack on Public Website",
  //     description: "Distributed denial of service attack overwhelming public-facing web services",
  //     status: "in-progress",
  //     severity: "high",
  //     createdAt: "2024-09-19T06:15:00Z",
  //     updatedAt: "2024-09-19T08:45:00Z",
  //     assignee: "Emily Davis",
  //     impactedSystems: ["Web Server", "Network Infrastructure"],
  //     tags: ["ddos", "availability", "public-facing"]
  //   },
  //   {
  //     id: "INC-2024-005",
  //     title: "Unauthorized Access Attempt",
  //     description: "Attempted privilege escalation detected on critical database server",
  //     status: "open",
  //     severity: "critical",
  //     createdAt: "2024-09-19T09:00:00Z",
  //     updatedAt: "2024-09-19T10:30:00Z",
  //     assignee: null,
  //     impactedSystems: ["Database", "Network Infrastructure"],
  //     tags: ["privilege-escalation", "database", "unauthorized-access"]
  //   },
  //   {
  //     id: "INC-2024-006",
  //     title: "Data Exfiltration Attempt",
  //     description: "Suspicious data transfer patterns indicating potential data theft",
  //     status: "open",
  //     severity: "critical",
  //     createdAt: "2024-09-19T10:45:00Z",
  //     updatedAt: "2024-09-19T11:20:00Z",
  //     assignee: "John Doe",
  //     impactedSystems: ["Database", "Network Infrastructure", "Firewall"],
  //     tags: ["data-exfiltration", "insider-threat", "monitoring"]
  //   },
  //   {
  //     id: "INC-2024-007",
  //     title: "Ransomware Indicators Detected",
  //     description: "File encryption patterns consistent with ransomware activity on file server",
  //     status: "in-progress",
  //     severity: "critical",
  //     createdAt: "2024-09-19T05:30:00Z",
  //     updatedAt: "2024-09-19T11:15:00Z",
  //     assignee: "Sarah Chen",
  //     impactedSystems: ["File Server", "Endpoint Security", "Network Infrastructure"],
  //     tags: ["ransomware", "encryption", "file-server"]
  //   },
  //   {
  //     id: "INC-2024-008",
  //     title: "SSL Certificate Expiration",
  //     description: "Critical SSL certificates expiring within 24 hours affecting secure communications",
  //     status: "resolved",
  //     severity: "medium",
  //     createdAt: "2024-09-18T16:00:00Z",
  //     updatedAt: "2024-09-19T08:00:00Z",
  //     assignee: "Mike Johnson",
  //     impactedSystems: ["Web Server", "Email System"],
  //     tags: ["ssl", "certificate", "maintenance"]
  //   },
  //   {
  //     id: "INC-2024-009",
  //     title: "Insider Threat Investigation",
  //     description: "Unusual access patterns from privileged user account requiring investigation",
  //     status: "open",
  //     severity: "high",
  //     createdAt: "2024-09-19T11:30:00Z",
  //     updatedAt: "2024-09-19T11:30:00Z",
  //     assignee: "Emily Davis",
  //     impactedSystems: ["Database", "File Server"],
  //     tags: ["insider-threat", "investigation", "privileged-access"]
  //   },
  //   {
  //     id: "INC-2024-010",
  //     title: "Firewall Rule Violation",
  //     description: "Multiple attempts to bypass firewall restrictions detected from internal network",
  //     status: "closed",
  //     severity: "low",
  //     createdAt: "2024-09-18T12:15:00Z",
  //     updatedAt: "2024-09-18T18:30:00Z",
  //     assignee: "John Doe",
  //     impactedSystems: ["Firewall", "Network Infrastructure"],
  //     tags: ["firewall", "policy-violation", "internal"]
  //   }
  // ];

  // State management
  const [filters, setFilters] = useState({
    search: '',
    status: '',
    severity: '',
    assignee: '',
    impactedSystem: '',
    dateRange: { start: '', end: '' }
  });
  
  const [selectedIncidents, setSelectedIncidents] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  // Filter and sort incidents
  const filteredAndSortedIncidents = useMemo(() => {

    if (!incidents.length) {
      return [];
    }

    let filtered = incidents?.filter(incident => {
      const matchesSearch = !filters?.search || 
        incident?.id?.toLowerCase()?.includes(filters?.search?.toLowerCase()) ||
        incident?.title?.toLowerCase()?.includes(filters?.search?.toLowerCase()) ||
        incident?.description?.toLowerCase()?.includes(filters?.search?.toLowerCase());
      
      const matchesStatus = !filters?.status || incident?.status === filters?.status;
      const matchesSeverity = !filters?.severity || incident?.severity === filters?.severity;
      const matchesAssignee = !filters?.assignee || 
        (filters?.assignee === 'unassigned' ? !incident?.assignee : incident?.assignee?.toLowerCase() === filters?.assignee);
      
      const matchesSystem = !filters?.impactedSystem || 
        incident?.impactedSystems?.some(system => 
          system?.toLowerCase() === filters?.impactedSystem
        );
      
      const matchesDateRange = (!filters?.dateRange?.start || 
        new Date(incident.createdAt) >= new Date(filters.dateRange.start)) &&
        (!filters?.dateRange?.end || 
        new Date(incident.createdAt) <= new Date(filters.dateRange.end));
      
      return matchesSearch && matchesStatus && matchesSeverity && 
             matchesAssignee && matchesSystem && matchesDateRange;
    });

    // Sort incidents
    filtered?.sort((a, b) => {
      let aValue = a?.[sortConfig?.key];
      let bValue = b?.[sortConfig?.key];
      
      if (sortConfig?.key === 'createdAt' || sortConfig?.key === 'updatedAt') {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }
      
      if (aValue < bValue) return sortConfig?.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig?.direction === 'asc' ? 1 : -1;
      return 0;
    });

    return filtered;
  }, [incidents, filters, sortConfig]);

  // Pagination
  const totalPages = Math.ceil(filteredAndSortedIncidents?.length / itemsPerPage);
  const paginatedIncidents = filteredAndSortedIncidents?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Calculate stats
  const stats = useMemo(() => {
    const total = filteredAndSortedIncidents?.length;
    const critical = filteredAndSortedIncidents?.filter(i => i?.severity === 'critical')?.length;
    const high = filteredAndSortedIncidents?.filter(i => i?.severity === 'high')?.length;
    const inProgress = filteredAndSortedIncidents?.filter(i => i?.status === 'in-progress')?.length;
    
    const today = new Date()?.toDateString();
    const resolvedToday = filteredAndSortedIncidents?.filter(i => 
      i?.status === 'resolved' && new Date(i.updatedAt)?.toDateString() === today
    )?.length;
    
    return { total, critical, high, inProgress, resolvedToday };
  }, [filteredAndSortedIncidents]);

  // Incident counts for header
  const incidentCounts = {
    critical: incidents.length ? incidents?.filter(i => i?.severity === 'critical' && i?.status !== 'closed')?.length : 0,
    high: incidents.length ? incidents?.filter(i => i?.severity === 'high' && i?.status !== 'closed')?.length : 0,
    medium: incidents.length ? incidents?.filter(i => i?.severity === 'medium' && i?.status !== 'closed')?.length : 0,
    low: incidents.length ? incidents?.filter(i => i?.severity === 'low' && i?.status !== 'closed')?.length : 0
  };

  // Event handlers
  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setFilters({
      search: '',
      status: '',
      severity: '',
      assignee: '',
      impactedSystem: '',
      dateRange: { start: '', end: '' }
    });
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev?.key === key && prev?.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleIncidentSelect = (incidentId, isSelected) => {
    setSelectedIncidents(prev => 
      isSelected 
        ? [...prev, incidentId]
        : prev?.filter(id => id !== incidentId)
    );
  };

  const handleSelectAll = () => {
    setSelectedIncidents(paginatedIncidents?.map(incident => incident?.id));
  };

  const handleDeselectAll = () => {
    setSelectedIncidents([]);
  };

  const handleBulkAction = (action, incidentIds) => {
    console.log(`Performing ${action} on incidents:`, incidentIds);
    // Handle bulk actions here
    setSelectedIncidents([]);
  };

  const handleExport = (format) => {
    console.log(`Exporting incidents in ${format} format`);
    // Handle export logic here
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSelectedIncidents([]);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    setSelectedIncidents([]);
  };

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} incidentCounts={incidentCounts} />
      <main className="nav-offset max-w-full px-4 sm:px-6 lg:px-8 py-6">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb />
          
          {/* Page Header */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-foreground">Incidents Management</h1>
              <p className="text-muted-foreground">
                Monitor, track, and manage cybersecurity incidents across your organization
              </p>
            </div>
            
            <Button
              variant="default"
              onClick={() => navigate('/create-incident')}
              iconName="Plus"
              iconPosition="left"
            >
              Create Incident
            </Button>
          </div>

          {/* Quick Stats */}
          <QuickStats stats={stats} />

          {/* Filter Toolbar */}
          <FilterToolbar
            filters={filters}
            onFiltersChange={handleFiltersChange}
            onClearFilters={handleClearFilters}
            totalResults={filteredAndSortedIncidents?.length}
            onExport={handleExport}
          />

          {/* Bulk Operations */}
          <BulkOperations
            selectedIncidents={selectedIncidents}
            onSelectAll={handleSelectAll}
            onDeselectAll={handleDeselectAll}
            isAllSelected={selectedIncidents?.length === paginatedIncidents?.length && paginatedIncidents?.length > 0}
            totalIncidents={paginatedIncidents?.length}
            onBulkAction={handleBulkAction}
          />

          {/* Incidents Table */}
          <IncidentsTable
            incidents={paginatedIncidents}
            selectedIncidents={selectedIncidents}
            onIncidentSelect={handleIncidentSelect}
            sortConfig={sortConfig}
            onSort={handleSort}
          />

          {/* Pagination */}
          {filteredAndSortedIncidents?.length > 0 && (
            <div className="mt-6">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={filteredAndSortedIncidents?.length}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </div>
          )}

          {/* Empty State */}
          {filteredAndSortedIncidents?.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 bg-muted rounded-full flex items-center justify-center">
                <Icon name="Search" size={24} className="text-muted-foreground" />
              </div>
              <h3 className="text-lg font-medium text-foreground mb-2">No incidents found</h3>
              <p className="text-muted-foreground mb-4">
                Try adjusting your filters or search criteria
              </p>
              <Button
                variant="outline"
                onClick={handleClearFilters}
                iconName="RefreshCw"
                iconPosition="left"
              >
                Clear Filters
              </Button>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default IncidentsList;